import React from 'react';
import {
  IRoleWithPermissionsFieldsFragment,
  IUserGroupFieldsFragment,
  IUserPermissionFieldsFragment,
  PermissionKey,
} from '../../utils/apollo/graphqlSchema';
import styled from 'styled-components';
import { DangerButton, PrimaryButton } from '../../components/Button';
import { usePermissionToggleMutation } from './hooks';
import usePermission from '../../utils/hooks/permissionHooks/usePermission';
import PermissionElementWrapper from './PermissionElementWrapper';
import { theme } from '../../styles/theme';

interface IProps {
  entity:
    | IUserPermissionFieldsFragment
    | IUserGroupFieldsFragment
    | IRoleWithPermissionsFieldsFragment;
  refetch: () => void;
  isActive: boolean;
}

const Footer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  margin-bottom: 8px;
`;

const Description = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

const ButtonContainer = styled.div`
  margin-top: 16px;
`;

const StyledDangerButton = styled(DangerButton)`
  width: 120px;
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  width: 120px;
`;

const PermissionEntityToggleButton = ({
  entity,
  refetch,
  isActive,
}: IProps) => {
  const { checkIsPermitted } = usePermission();
  const isPermittedToDisable = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminDelete],
  });
  const buttonType = isActive ? 'disableButton' : 'enableButton';
  const { textDictionary, mutation } = usePermissionToggleMutation({
    entity,
    buttonType,
  });
  const onClickSubmit = async () => {
    await mutation();
    refetch();
  };
  return (
    <Footer>
      <Title>{textDictionary.name}</Title>
      <Description>{textDictionary.description}</Description>
      <PermissionElementWrapper isPermitted={isPermittedToDisable}>
        <ButtonContainer>
          {buttonType === 'disableButton' ? (
            <StyledDangerButton
              type="button"
              disabled={!isPermittedToDisable}
              onClick={onClickSubmit}
              trackContext={textDictionary.trackContext}
              trackAction={textDictionary.trackAction}
            >
              {textDictionary.name}
            </StyledDangerButton>
          ) : (
            <StyledPrimaryButton
              type="button"
              disabled={!isPermittedToDisable}
              onClick={onClickSubmit}
              trackContext={textDictionary.trackContext}
              trackAction={textDictionary.trackAction}
            >
              {textDictionary.name}
            </StyledPrimaryButton>
          )}
        </ButtonContainer>
      </PermissionElementWrapper>
    </Footer>
  );
};

export default PermissionEntityToggleButton;
